import MaterialIcon from './MaterialIcon'
import { KILO } from '../../constants/KILO_THEME'

type MetricPreviewCardProps = {
  label: string
  value?: number | null
  unit?: string
  icon: string
  formattedValue?: string | null
  onClick: () => void
}

const MetricPreviewCard = ({ label, value, unit, icon, formattedValue, onClick }: MetricPreviewCardProps) => {
  const display =
    formattedValue ??
    (value != null ? (value % 1 === 0 ? String(value) : value.toFixed(1)) : '—')

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative flex min-h-[9.5rem] w-full flex-col items-center justify-center rounded-xl border border-kilo-border bg-kilo-card px-4 py-5 text-center transition-colors hover:border-kilo-accent/30 active:bg-kilo-nested/50"
    >
      <MaterialIcon name={icon} size="md" className="mb-2 shrink-0 text-kilo-muted" />
      <p className={`max-w-full text-[10px] font-bold uppercase leading-snug tracking-widest ${KILO.text.soft}`}>
        {label}
      </p>
      <div className="mt-3 flex shrink-0 items-baseline justify-center gap-1">
        <span className={`text-2xl font-semibold leading-none ${KILO.text.primary}`}>{display}</span>
        {formattedValue == null && value != null && unit ? (
          <span className={`text-sm leading-none ${KILO.text.muted}`}>{unit}</span>
        ) : null}
      </div>
      <MaterialIcon
        name="chevron_right"
        size="sm"
        className="pointer-events-none absolute right-3 top-1/2 shrink-0 -translate-y-1/2 text-kilo-soft"
      />
    </button>
  )
}

export default MetricPreviewCard
